export default {
  SELECT_FORM: "SELECT_FORM",
  CALENDAR: "CALENDAR",
  TIME_SELECT: "TIME_SELECT",
  FIRST_DATE_TIME_MESSAGE: "FIRST_DATE_TIME_MESSAGE",
  CITA_PREVIA_FORM: "CITA_PREVIA_FORM",
  CONFIRM_MESSAGE: "CONFIRM_MESSAGE",
};
